var _path, _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,52.64A21.91,21.91,0,1,0,13.69,30.52"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "5.79 21.06 13.67 31.35 23.96 23.48"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "34.95 14.04 34.95 32.35 43.26 38.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorySvgrepoCom);
export default __webpack_public_path__ + "static/media/history-svgrepo-com.f3e4018d145b06b07d5175c4aaa14d3a.svg";
export { ForwardRef as ReactComponent };